import { ConnectProto } from "@racoon/api";

// JobCategory and RouteCategory share names but not numbers (TIPPER/DISINFECTION swap).
export const GRPC_ROUTE_CATEGORY_TO_JOB_CATEGORY: Record<
  ConnectProto.RouteCategory,
  ConnectProto.JobCategory
> = {
  [ConnectProto.RouteCategory.UNDEFINED]: ConnectProto.JobCategory.UNDEFINED,
  [ConnectProto.RouteCategory.CO]: ConnectProto.JobCategory.CO,
  [ConnectProto.RouteCategory.MSW]: ConnectProto.JobCategory.MSW,
  [ConnectProto.RouteCategory.LIQUID]: ConnectProto.JobCategory.LIQUID,
  [ConnectProto.RouteCategory.TIPPER]: ConnectProto.JobCategory.TIPPER,
  [ConnectProto.RouteCategory.DISINFECTION]: ConnectProto.JobCategory.DISINFECTION,
};
